import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

/**
 * Breadcrumb navigation component for user orientation and SEO
 * @param {Array<{ label: string, href?: string }>} items
 * @param {boolean} isDark - for dark backgrounds (e.g. Hero sections)
 */
export default function Breadcrumbs({ items = [], isDark = false, className = '' }) {
  if (!items || items.length === 0) return null;

  const allItems = [
    { label: 'Forside', href: '/' },
    ...items
  ];

  return (
    <nav 
      aria-label="Brødkrummesti" 
      className={`flex items-center flex-wrap gap-1.5 text-xs sm:text-sm ${className}`}
    >
      <ol className="flex items-center flex-wrap gap-1.5">
        {allItems.map((item, index) => {
          const isLast = index === allItems.length - 1;

          return (
            <li key={index} className="inline-flex items-center gap-1.5">
              {index > 0 && (
                <ChevronRight 
                  className={`w-3.5 h-3.5 flex-shrink-0 ${
                    isDark ? 'text-stone-400' : 'text-stone-400'
                  }`} 
                  aria-hidden="true" 
                />
              )}
              {isLast || !item.href ? (
                <span 
                  className={`font-medium truncate max-w-[200px] sm:max-w-none ${
                    isDark ? 'text-orange-400' : 'text-orange-600'
                  }`}
                  aria-current="page"
                >
                  {item.label}
                </span>
              ) : (
                <Link
                  to={item.href}
                  className={`inline-flex items-center gap-1 transition-colors hover:text-orange-500 ${
                    isDark ? 'text-stone-300 hover:text-white' : 'text-stone-600 hover:text-stone-900'
                  }`}
                >
                  {index === 0 && <Home className="w-3.5 h-3.5" aria-hidden="true" />}
                  <span>{item.label}</span>
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
